/* eslint-disable no-undef */

import React, { PureComponent } from 'react'
import QuestionPage from './QuestionPage'
import { withStyles } from '@material-ui/core/styles/index'
import '../index.css'
import { styles } from './QuestionPageWrapper.styles'
import QuestionPageNavigation from './partials/QuestionPageNavigation'
import { LinearProgress, Typography } from '@material-ui/core'
import parse from 'html-react-parser'
import { Box } from '@material-ui/core'

class QuestionPageWrapper extends PureComponent {
    render() {
        const {
            classes,
            questionPage,
            pageAlias,
            isLoading,
            activeStep,
            onNext,
            childNext,
            childPrev,
            questionPageRef,
            visitorSessionId,
            theme
        } = this.props

        const hasUserSpecificContent = (theme && theme.footerDescription) || (theme && theme.footerImage)

        return (
            <>
                {isLoading && questionPage.showLoadingBar && (
                    <LinearProgress className={classes.loader} classes={{ root: classes.progressBarRoot, bar: classes.progressBarBar }} />
                )}
                {questionPage && questionPage.id && (
                    <QuestionPage
                        questionPage={questionPage}
                        onSubmit={onNext}
                        next={childNext}
                        innerRef={questionPageRef}
                        alias={pageAlias}
                        isLoading={isLoading}
                        visitorSessionId={visitorSessionId}
                        theme={theme}
                    />
                )}
                {questionPage && questionPage.showNavigation && (
                    <QuestionPageNavigation
                        questionPage={questionPage}
                        isLoading={isLoading}
                        next={childNext}
                        prev={childPrev}
                        activeStep={activeStep}
                        theme={theme}
                    />
                )}
                {hasUserSpecificContent ? (
                    <Box className={'app-question-page-id-' + questionPage?.id + ' footer-content'}>
                        {theme && theme.footerDescription && <Typography component={'p'}>{theme.footerDescription}</Typography>}
                        {theme && theme.footerImage && (
                            <Box className="footer-content-img-wrapper">
                                <img src={theme.footerImage} />
                            </Box>
                        )}
                    </Box>
                ) : (
                    <>
                        {theme && theme.footerContent && (
                            <Box className={'app-question-page-id-' + questionPage?.id + ' footer-content'}>{parse(theme.footerContent)}</Box>
                        )}
                    </>
                )}
            </>
        )
    }
}

export default withStyles(styles)(QuestionPageWrapper)
